/* eslint-disable no-useless-escape */
import { useEffect, useRef } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { log } from '../../helpers/iframeHelper';
import I18n from '../../locales';
import HOC from '../HOC';

const URL = require('url-parse');
const queryString = require('query-string');

const Loading = ({
  setProject,
  setDistrict,
  setUuid,
  setLang,
  setAppStage,
  setRrGameOnly,
}) => {
  const windowRef = useRef(window);
  const history = useHistory();

  if (window.location.search.replace(/^.*?\=/, '') === 'navigate/rr-game-tab') {
    setRrGameOnly(true);
  }
  const recieveMessage = (event) => {
    try {
      if (event && event.data) {
        let url = '';
        if (!event.data.includes('recycledz')) url += 'recycledz://';
        const { hostname, pathname, query } = new URL(`${url}${event.data}`);
        if (hostname === 'navigate') {
          switch (pathname) {
            case '/rf_quiz':
              history.push('/quiz/rf/0');
              break;
            case '/rf':
              history.push(`/lesson-details/rf/${queryString.parse(query).campaign_id}`);
              break;
            case '/mm': {
              const { mat_id } = queryString.parse(query);
              history.push(`/lesson-details/mum/${mat_id}`);
              break;
            }
            case '/mm_quiz':
              history.push('/quiz/mum/0');
              break;
            case '/recycle-right':
              history.replace('/recycle-right');
              break;
            case '/rr-game-tab':
              setRrGameOnly(true);
              history.replace('/recycle-right-initial');

              break;
            case '/home':
              history.replace('/landing');
              break;
            default:
              history.replace('/landing');
              break;
          }
        }
      }
      return null;
    } catch (e) {
      return null;
    }
  };
  /**
   * Handle deep linking
   */
  windowRef.current.addEventListener('message', recieveMessage);

  useEffect(() => {
    const { hostname, pathname, query } = new URL(`recycledz://${window.deepLink}`);
    if (hostname === 'navigate') {
      switch (pathname) {
        case '/rf_quiz':
          history.push('/quiz/rf/0');
          break;
        case '/rf':
          history.push(`/lesson-details/rf/${queryString.parse(query).campaign_id}`);
          break;
        case '/mm': {
          const { mat_id } = queryString.parse(query);
          history.push(`/lesson-details/mum/${mat_id}`);
          break;
        }
        case '/mm_quiz':
          history.push('/quiz/mum/0');
          break;
        case '/home':
          history.replace('/landing');
          break;
        default:
          history.replace('/landing');
          break;
      }
    }
  }, [window.deepLink]);

  /**
   * Set necesseary data globally using redux to use
   * in other components and pages
   */
  useEffect(() => {
    setProject(window.projectId);
    setDistrict(window.districtId);
    setUuid(window.uuid);
    setLang(window.lang);
    I18n.locale = window.lang;
    setAppStage(window.appStage || '1');
  }, [
    setProject,
    setDistrict,
    setUuid,
    setLang,
    setAppStage
  ]);

  if (window.initialScreen) {
    try {
      return (
        <Redirect to={`/${window.initialScreen}`} />
      );
    } catch (e) {
      //
    }
  }

  /**
   * Redirect user after data fetch
   */
  return (
    <>
      <Redirect to="/landing" />
    </>
  );
};

export default HOC(Loading);
